import MadmaxPixiLayer from "../MadmaxPixiLayer";

export default class MadmaxInfo extends MadmaxPixiLayer {

    constructor(gameset) {
        super();

        this.gameset = gameset;

        this._stageWidth = gameset.stageWidth;
        this._stageHeight = gameset.stageHeight;

        this._pages = [];
        this._currentPage = 0;
        this._pagesCount = 0;
    }

    /**
     *
     * @param directionLeft
     * @return {number}
     */
    move (directionLeft) {

        if (this._pagesCount < 2) return this._currentPage;

        if (directionLeft) {

            if(this._currentPage == this._pagesCount-1) {

                this._pages[this._currentPage].position.x =- this._stageWidth;
                this._pages[0].position.x = 0;
                this._currentPage = 0;
            } else {

                this._pages[this._currentPage].position.x =- this.stageWidth;
                this._pages[this._currentPage +1 ].position.x = 0;
                this._currentPage = this._currentPage + 1;
            }
        } else {

            if(this._currentPage == 0) {

                this._pages[this._currentPage].position.x = this._stageWidth;
                this._pages[this._pagesCount - 1].position.x = 0;
                this._currentPage = this._pagesCount - 1;
            } else {

                this._pages[this._currentPage].position.x = this._stageWidth;
                this._pages[this._currentPage -1 ].position.x = 0;
                this._currentPage = this._currentPage - 1;
            }
        }

        return this._currentPage;
    }

    /**
     * Add page to this.pages, increase this.pagesCount
     * @param page {PIXI.Container}
     */
    addPage (page) {

        this._pages.push(page);
        this._pagesCount = this._pages.length;
    }

    /**
     * Set current page to first page (this.pages[0])
     */
    _resetPages() {

        if (this._pagesCount < 2) return;

        this._pages[this._currentPage].position.x = this._stageWidth;
        this._pages[0].position.x = 0;
        this._currentPage = 0;
    }

    show() {
        return this.visible = true;
    }

    hide() {
        return this.visible = false;
    }

    toggle() {
        this._resetPages();
        return this.visible ? this.hide() : this.show();
    }

}
